import React, { useEffect, useState } from 'react';
import { useNotionContext } from '../context';
import { GracefulImage } from './graceful-image';
export var ExternalComponentGoogleDoc = function (_a) {
    var original_url = _a.original_url, block = _a.block;
    var _b = useNotionContext(), components = _b.components, mapImageUrl = _b.mapImageUrl;
    var url = new URL(original_url);
    var _c = useState(url.pathname.substring(1)), name = _c[0], setName = _c[1];
    var _d = useState(''), filesize = _d[0], setFileSize = _d[1];
    var _e = useState(''), extension = _e[0], setExtension = _e[1];
    var _f = useState(''), previewimage = _f[0], setPreviewImage = _f[1];
    useEffect(function () {
        ;
        (block.format.attributes || []).forEach(function (att) {
            if (att.id == 'title') {
                setName(att.values[0]);
            }
            else if (att.id == 'file_size') {
                setFileSize(att.values[0]);
            }
            else if (att.id == 'extension') {
                setExtension(att.values[0]);
            }
            else if (att.id == 'preview_image') {
                setPreviewImage(att.values[0]);
            }
        });
    }, [block]);
    var content = (React.createElement("div", { className: 'notion-google-drive-preview', style: { height: '700px' } },
        React.createElement(GracefulImage, { src: mapImageUrl(previewimage, block), alt: 'Google Drive Document', loading: 'lazy' })));
    return (React.createElement(components.link, { target: '_blank', rel: 'noopener noreferrer', href: original_url, style: {
            width: '100%',
            padding: '0px',
            borderRadius: '10px',
            border: '1px solid rgba(55, 53, 47, 0.09)'
        } },
        content,
        React.createElement("div", { className: 'notion-external-information', style: {
                padding: '10px',
                borderTop: '1px solid rgba(55, 53, 47, 0.09)'
            } },
            React.createElement("div", { className: 'notion-external-image' },
                React.createElement("img", { width: '33.744px', src: 'https://upload.wikimedia.org/wikipedia/commons/1/12/Google_Drive_icon_%282020%29.svg', alt: 'icon' })),
            React.createElement("div", { className: 'notion-external-description' },
                React.createElement("div", { className: 'notion-external-title' }, name),
                React.createElement("div", { className: 'notion-external-subtitle' },
                    React.createElement("span", null, filesize),
                    extension && (React.createElement(React.Fragment, null,
                        React.createElement("span", null, " \u2022 "),
                        React.createElement("span", null, extension))),
                    React.createElement(React.Fragment, null,
                        React.createElement("span", null, " \u2022 "),
                        React.createElement("span", null, "https://docs.google.com")))))));
};
export var ExternalComponentGoogleDrive = function (_a) {
    var original_url = _a.original_url, block = _a.block;
    var components = useNotionContext().components;
    var url = new URL(original_url);
    var _b = useState(url.pathname.substring(1)), name = _b[0], setName = _b[1];
    var _c = useState(''), filesize = _c[0], setFileSize = _c[1];
    var _d = useState(''), extension = _d[0], setExtension = _d[1];
    useEffect(function () {
        ;
        (block.format.attributes || []).forEach(function (att) {
            if (att.id == 'title') {
                setName(att.values[0]);
            }
            else if (att.id == 'file_size') {
                setFileSize(att.values[0]);
            }
            else if (att.id == 'extension') {
                setExtension(att.values[0]);
            }
        });
    }, [block]);
    return (React.createElement(components.link, { target: '_blank', rel: 'noopener noreferrer', href: original_url, style: {
            width: '100%',
            padding: '0px',
            borderRadius: '10px',
            border: '1px solid rgba(55, 53, 47, 0.09)'
        } },
        React.createElement("div", { className: 'notion-external-information', style: {
                padding: '10px',
                borderTop: '1px solid rgba(55, 53, 47, 0.09)'
            } },
            React.createElement("div", { className: 'notion-external-image' },
                React.createElement("img", { width: '33.744px', src: 'https://upload.wikimedia.org/wikipedia/commons/1/12/Google_Drive_icon_%282020%29.svg', alt: 'icon' })),
            React.createElement("div", { className: 'notion-external-description' },
                React.createElement("div", { className: 'notion-external-title' }, name),
                React.createElement("div", { className: 'notion-external-subtitle' },
                    React.createElement("span", null, filesize),
                    extension && (React.createElement(React.Fragment, null,
                        React.createElement("span", null, " \u2022 "),
                        React.createElement("span", null, extension))),
                    React.createElement(React.Fragment, null,
                        React.createElement("span", null, " \u2022 "),
                        React.createElement("span", null, "https://drive.google.com")))))));
};
//# sourceMappingURL=external-component-google.js.map